import './App.css';
import {Route, RouterProvider, createBrowserRouter, createRoutesFromElements} from "react-router-dom";
import BodyElement from './elements/BodyElement';
import Home from './components/home/Home';
import About from './components/about/About';
import How from './components/how/How';
import Blog from './components/blog/Blog';
import Features from './components/features/Features';
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<BodyElement />} path='/'>
      <Route index element={<Home />}/>
      <Route path='about' element={<About />} />
      <Route path='how-it-works' element={<How />} />
      <Route path='blog' element={<Blog />} />
      <Route path='features' element={<Features />} />
    </Route>
  )
)
function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
